
export const STATUS_CONSTANT = {
  PASS: "PASS",
  FAIL: "FAIL",
} as const;


export const ENQ_STATUS = {
  IN_PROGRESS: "In Progress",
  LOST: "Lost",
  CONVERTED: "Converted",
}

export const ENQ = {
  ENQUIRY_LOG: "enquiry_log",
  DRAFT: "draft"
}

export const ENQUIRY_TYPE = {
  PRODUCT: "ENQUIRY_PRODUCT",
  SERVICE: "ENQUIRY_SERVICE",
} as const;


export const QUOTATION_STAGE = {
  DRAFT: "Draft",
  LOG: "Log",
} as const;

export const QUOTATION_TYPE = {
  PRODUCT: "QUOTATION_PRODUCT",
  SERVICE: "QUOTATION_SERVICE",
} as const;

export const SALES_ORDER_TYPE = {
  PRODUCT: "SALES_ORDER_PRODUCT",
  SERVICE: "SALES_ORDER_SERVICE",
} as const;

export const SALES_ORDER_CATEGORY = {
  OTHERS: "Other",
  PBG: "Pbg",
  RETENTION: "Retention",
  ORDER: "Order",
} as const;

export type FollowUpCategory =
  (typeof SALES_ORDER_CATEGORY)[keyof typeof SALES_ORDER_CATEGORY];
